import React, { useState } from 'react'
import { FormBox, Wrapper } from './styles'
import { Button, Card, Form, Input, InputNumber, Typography } from 'antd'
import PNInput from "react-phone-number-input/input";
import { auth } from '../../utils/firebase';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { useLogin, useMe } from '../../zustand/store';
import { useNavigate } from 'react-router-dom';

// const auth = getAuth();

const initial = {
    loading: false,
    success: false,
    error: false
}
const PhoneNumber = ({ setVerificationId, setConfirmationResult }) => {

    // auth.settings.appVerificationDisabledForTesting = false;
    const [status, setStatus] = useState(initial)
    const [phoneNumber, setPhoneNumber] = useState("");
    const setupRecaptcha = () => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                'size': 'invisible',
                'callback': function (response) {
                    // reCAPTCHA solved - proceed with phone number authentication
                }
            });
        }
    };

    const sendVerificationCode = () => {
        setStatus({ ...initial, loading: true })
        setupRecaptcha();
        const appVerifier = window.recaptchaVerifier;
        console.log(phoneNumber);
        signInWithPhoneNumber(auth, phoneNumber, appVerifier)
            .then((confirmationResult) => {
                setConfirmationResult(confirmationResult)
                // setVerificationId(confirmationResult.verificationId);
                console.log('SMS sent!');
                setStatus({ ...initial, success: true })

            })
            .catch((error) => {
                console.error('Error during signInWithPhoneNumber', error);
                window.recaptchaVerifier.clear();
                setStatus({ ...initial, error: true })
            });
    };
    return <FormBox>
        <Card >
            <Form size='large'
                layout='vertical'
            // onFinish={sendVerificationCode}
            >
                <Form.Item
                    label={<Typography.Title level={3} style={{ margin: 0 }}>Phone Number</Typography.Title>}
                >
                    <PNInput
                        value={phoneNumber}
                        onChange={(e) => {
                            setPhoneNumber(e)
                        }}
                        className="input-phone-number ant-input css-dev-only-do-not-override-1e3x2xa"
                        // inputComponent={Input}
                        // defaultValue="+1"
                        defaultCountry='US'
                        //   placeholder={text({ id: "enterPhoneNumber" })}
                        placeholder='+18434460396'
                    />
                    {/* <Input placeholder='+18434460396' /> */}
                </Form.Item>
                <Form.Item style={{ margin: 0 }}>
                    <Button loading={status.loading} onClick={sendVerificationCode} htmlType='submit' block type='primary'>Submit</Button>
                </Form.Item>
            </Form>
        </Card>
    </FormBox>
}

const Code = ({ confirmationResult }) => {
    const [status, setStatus] = useState(initial)
    const login = useLogin();
    const me = useMe();
    const [code, setCode] = useState("");
    const navigate = useNavigate();
    const verifyCode = (e) => {
        setStatus({ ...initial, loading: true })
        console.log(code);
        confirmationResult.confirm(code)
            .then((result) => {
                console.log('User signed in successfully:', result.user);
                const accessToken = result?.user?.accessToken;
                login.execute({
                    data: { accessToken },
                    onSuccess: (res) => {
                        const data = res.data;
                        const token = data.token;
                        localStorage.setItem("cars_token", token);
                        navigate("/");
                        me.execute({ force: true });
                        setStatus({ ...initial, success: true })
                    }
                });
            })
            .catch((error) => {
                console.error('Error during signInWithCredential', error);
                setStatus({ ...initial, error: true })
            });
    };
    return <FormBox>
        <Card >
            <Form layout='vertical' size='large' onFinish={verifyCode}>
                <Form.Item name={"code"} label={<Typography.Title level={3} style={{ margin: 0 }}>Code</Typography.Title>}>
                    <Input value={code} onChange={(e) => { setCode(e?.target?.value); }} />
                </Form.Item>
                <Form.Item style={{ margin: 0 }}>
                    <Button loading={status.loading} htmlType='submit' block type='primary'>Submit</Button>
                </Form.Item>
            </Form>
        </Card>
    </FormBox>
}

function AuthPage() {
    const [code, setCode] = useState(true)
    const [verificationId, setVerificationId] = useState('');
    const [confirmationResult, setConfirmationResult] = useState();
    return (
        <Wrapper>
            {
                confirmationResult ? <Code confirmationResult={confirmationResult} verificationId={verificationId} /> : <PhoneNumber setConfirmationResult={setConfirmationResult} setVerificationId={setVerificationId} />
            }
            <div id="recaptcha-container" />
        </Wrapper>
    )
}

export default AuthPage